import { FilterInputType, StateType } from './ContentFilter';
import FilterSelect from './FilterSelect';
import { __t } from './i18n';
import { Row } from './styles';

const sort = ['type', 'default', 'genre', 'territory', 'flags', 'order'];

type FilterListProps = {
  filters: FilterInputType[];
  value: StateType;
  onChange: (key: string, value: string, type: string) => void;
}

export default function FilterList({ filters, value, onChange: handleChange }: FilterListProps) {
  const sortedFilters = [...filters].sort((a, b) => (sort.indexOf(a.label) - sort.indexOf(b.label)));

  return (
    <Row cols={{ xs: 1, sm: 2, md: 3, lg: 6 }}>
      {sortedFilters.map(({ field, label, options, type }) => (
        <FilterSelect
          key={label}
          value={value[field]}
          onChange={handleChange}
          field={field}
          type={type}
          label={__t('filter.' + label)}
          options={options}
        />
      ))}
    </Row>
  );
}
